export default "__VITE_ASSET__Dl5DIAy6__"